import { render, staticRenderFns } from "./DealDetail.vue?vue&type=template&id=d3cb7112&"
import script from "./DealDetail.vue?vue&type=script&lang=ts&"
export * from "./DealDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports